import React, { useState } from "react";

const EmergencyRegistration = ({ data, updateData }) => {
  const [formState, setFormState] = useState(data || {});

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...formState, [name]: value };
    setFormState(updatedForm);
    updateData(updatedForm); // Update the parent component's state
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add submission logic if needed
    console.log("Emergency Registration Submitted", formState);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Patient Name */}
        <div>
          <label
            htmlFor="patientName"
            className="block text-gray-700 font-medium"
          >
            Patient Name
          </label>
          <input
            type="text"
            id="patientName"
            name="patientName"
            placeholder="Enter patient name"
            value={formState.patientName || ""}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {/* Age/Approximate Age */}
        <div>
          <label htmlFor="age" className="block text-gray-700 font-medium">
            Age/Approximate Age
          </label>
          <input
            type="number"
            id="age"
            name="age"
            placeholder="Enter age"
            value={formState.age || ""}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {/* Gender */}
        <div>
          <label htmlFor="gender" className="block text-gray-700 font-medium">
            Gender
          </label>
          <select
            id="gender"
            name="gender"
            value={formState.gender || ""}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>

        {/* Primary Complaint */}
        <div>
          <label
            htmlFor="primaryComplaint"
            className="block text-gray-700 font-medium"
          >
            Primary Complaint
          </label>
          <textarea
            id="primaryComplaint"
            name="primaryComplaint"
            placeholder="Describe the primary complaint"
            value={formState.primaryComplaint || ""}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {/* Mode of Arrival */}
        <div>
          <label
            htmlFor="modeOfArrival"
            className="block text-gray-700 font-medium"
          >
            Mode of Arrival
          </label>
          <select
            id="modeOfArrival"
            name="modeOfArrival"
            value={formState.modeOfArrival || ""}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select mode of arrival</option>
            <option value="Ambulance">Ambulance</option>
            <option value="Walk-in">Walk-in</option>
            <option value="Referral">Referral</option>
          </select>
        </div>

        {/* Contact Person */}
        <div>
          <label
            htmlFor="contactPerson"
            className="block text-gray-700 font-medium"
          >
            Contact Person
          </label>
          <input
            type="text"
            id="contactPerson"
            name="contactPerson"
            placeholder="Enter contact person's name"
            value={formState.contactPerson || ""}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {/* Triage Level */}
        <div>
          <label
            htmlFor="triageLevel"
            className="block text-gray-700 font-medium"
          >
            Triage Level
          </label>
          <select
            id="triageLevel"
            name="triageLevel"
            value={formState.triageLevel || ""}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select triage level</option>
            <option value="Critical">Critical</option>
            <option value="High Priority">High Priority</option>
            <option value="Moderate">Moderate</option>
          </select>
        </div>
      </div>

      {/* Submit Button */}
      <div className="flex justify-end">
        <button
          type="submit"
          className="px-6 py-2 bg-[btn-primary] text-white rounded-md shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Submit
        </button>
      </div>
    </form>
  );
};

export default EmergencyRegistration;
